import { AuthenticationGuard } from "@authentication/components/AuthenticationGuard";
import { Breadcrumbs } from "@components/Breadcrumbs";
import { Error } from "@components/Error";
import { ILSParagraphPlaceholder } from "@components/ILSPlaceholder";
import { BackOfficeRoutes, FrontSiteRoutes } from "@routes/urls";
import PropTypes from "prop-types";
import React from "react";
import Overridable from "react-overridable";
import { Link } from "react-router-dom";
import { Container, Grid, Icon, Label } from "semantic-ui-react";
import SpecialCollectionMetadata from "./SpecialCollectionMetadata/SpecialCollectionMetadata";
import SpecialCollectionPanel from "./SpecialCollectionPanel/SpecialCollectionPanel";

const SpecialCollectionDetailsLayout = ({
  error,
  isLoading,
  specialCollection,
}) => {
  if (isLoading || !specialCollection || !specialCollection.metadata) {
    return (
      <Container className="document-details-container default-margin-top">
        <ILSParagraphPlaceholder isLoading={isLoading} linesNumber={10} />
      </Container>
    );
  }

  const breadcrumbs = () => [
    { to: FrontSiteRoutes.home, label: "Home" },
    { to: FrontSiteRoutes.documentsList, label: "Search" },
  ];

  return (
    <Overridable
      id="SpecialCollectionDetails.layout"
      {...{ error, isLoading, specialCollection }}
    >
      <Error boundary error={error}>
        <Container className="document-details-container default-margin-top">
          <ILSParagraphPlaceholder isLoading={isLoading} linesNumber={1}>
            <Grid columns={2}>
              <Grid.Column computer={13} tablet={13} mobile={16}>
                <Breadcrumbs
                  isLoading={isLoading}
                  elements={breadcrumbs()}
                  currentElement={specialCollection.metadata.title}
                />
              </Grid.Column>
              <Grid.Column
                computer={3}
                tablet={3}
                mobile={16}
                textAlign="right"
              >
                <AuthenticationGuard
                  silent
                  authorizedComponent={() => (
                    <Label
                      as={Link}
                      to={BackOfficeRoutes.specialCollectionDetailsFor(
                        specialCollection.metadata.pid
                      )}
                      color="grey"
                    >
                      <Icon name="cogs" />
                      Open in Backoffice
                    </Label>
                  )}
                  roles={["admin", "librarian"]}
                  loginComponent={() => null}
                />
              </Grid.Column>
            </Grid>
          </ILSParagraphPlaceholder>
          <SpecialCollectionPanel
            isLoading={isLoading}
            specialCollectionDetails={specialCollection}
          />

          {/* Main metadata display */}
          <Container className="section spaced">
            <SpecialCollectionMetadata metadata={specialCollection} />
          </Container>
        </Container>
      </Error>
    </Overridable>
  );
};

SpecialCollectionDetailsLayout.propTypes = {
  specialCollection: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.object,
};

SpecialCollectionDetailsLayout.defaultProps = {
  error: null,
};

export default Overridable.component(
  "SpecialCollectionDetailsLayout",
  SpecialCollectionDetailsLayout
);
